import React from 'react';
import {
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from '@chakra-ui/react';
import {ObjectId} from 'bson';
import {useDeleteIntentSource} from '../../../hooks/api/intent';

interface DeleteIntentSourceModalProps {
  isOpen: boolean;
  onClose: () => void;
  sourceIdToDelete?: ObjectId;
}

export const DeleteIntentSourceModal = ({
  isOpen,
  onClose,
  sourceIdToDelete,
}: DeleteIntentSourceModalProps) => {
  const toast = useToast();
  const deleteIntentSource = useDeleteIntentSource();

  return (
    <Modal isCentered={true} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontWeight="normal" pb="1" pt="6">
          Delete Intent Source
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody px="6" pt="6" pb="8" color="kgray.300">
          This action can&#39;t be undone.
        </ModalBody>
        <Divider />
        <ModalFooter justifyContent="start" gap="4">
          <Button
            colorScheme="red"
            onClick={() => {
              if (sourceIdToDelete) {
                deleteIntentSource.mutate(
                  {sourceId: sourceIdToDelete},
                  {
                    onSuccess: () => {
                      toast({
                        status: 'warning',
                        title: 'Intent source deleted.',
                        duration: 2_000,
                        isClosable: true,
                      });
                    },
                  }
                );
              }
              onClose();
            }}
          >
            Delete
          </Button>
          <Button color="kgray.300" onClick={onClose} variant="ghost">
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
